import React from 'react';
import './App.css';
import 'antd/dist/antd.css';
import Stepper from "./pages/steps/Stepper";
import PaymentPage from "./pages/PaymentPage";
import ResultPage from "./pages/Result";

import {
  BrowserRouter,
  Switch,
  Route, Redirect,
} from "react-router-dom";

const routes =
  <Switch>
    <Route exact path="/">
      <Redirect to="/obracun"/>
    </Route>
    <Route exact path={"/obracun"}>
      <Stepper/>
    </Route>
    <Route exact path={"/payment"}>
      <PaymentPage/>
    </Route>
    <Route path={"/result/:result/:pdf/:calc"}>
      <ResultPage/>
    </Route>
  </Switch>;

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={'/mps'} >
        {routes}
      </BrowserRouter>
    </div>
  );
}

export default App;
